import BasePage from '../../../../../components/table_page';
import Form from './form';

export default {
  name: 'fiscal_year_set',
  extends: BasePage,
  data() {
    return {};
  },
  components: {
    Form,
  },
  created() {
    this.getConfigList('tpm_budget_year_jiulei');
  },
  methods: {
    modalClick({ val, row }) {
      if (val.code === 'add' || val.code === 'edit' || val.code === 'view') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        this.modalConfig.width = '500px';
        this.modalConfig.title = val.name || '查看';

        this.openModal();
      }
    },
  },
};
